/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    /** Represents the Start screen */
    Start = "start",
    /** Represents the Intro screen */
    Intro = "intro",
    /** Represents the ending screen */
    Ending = "ending",
};
